import {
    FieldConfig,
    SkyNetSpreadSheetCellType,
    SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    Fee,
} from 'app/Apps/Pricing/Pricing.types'
import {
    ContractCurrency,
} from 'app/enums/label.enums'
import {
    FeeCells,
} from '../Fee.types'

const getFeesSpreadSheetConfig = ({
    feeNameOptions,
    productTypesOptions,
    getChargeabilityOptions,
    showProductTypeSelect,
    showPercentage,
    showFeeValue,
    currency,
    getLabel,
}: {
    feeNameOptions: Record<string, string>,
    productTypesOptions: Record<string, string>,
    getChargeabilityOptions: (value: Fee) => [any, string][]
    showProductTypeSelect: (value: Fee) => boolean,
    showPercentage: (value: Fee) => boolean,
    showFeeValue: (value: Fee) => boolean,
    currency: ContractCurrency
    getLabel: (...args: any[]) => string,
}): SkyNetSpreadSheetConfigType<keyof FeeCells> => {
    const fields: FieldConfig<keyof FeeCells>[] = [
        {
            name: 'feeName',
            title: getLabel('Fee.feeName'),
            width: 200,
            required: true,
            allowedValues: feeNameOptions,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
        },
        {
            name: 'feeChargeability',
            title: getLabel('Fee.feeChargeability'),
            width: 250,
            required: true,
            getAllowedValues: getChargeabilityOptions,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
            },
        },
        {
            name: 'productType',
            title: getLabel('Fee.productType'),
            width: 120,
            required: true,
            allowedValues: productTypesOptions,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.SELECT,
                conditionalType: [[
                    showProductTypeSelect,
                    SkyNetSpreadSheetCellType.NO_VALUE,
                ]],
            },
        },
        {
            name: 'feeDescription',
            title: getLabel('Fee.feeDescription'),
            width: 300,
        },
        {
            name: 'feeValue',
            title: currency || getLabel('BestOptions.price'),
            width: 75,
            required: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.NUMBER,
                conditionalType: [
                    [
                        showFeeValue,
                        SkyNetSpreadSheetCellType.NO_VALUE,
                    ],
                    [
                        showPercentage,
                        SkyNetSpreadSheetCellType.PERCENTAGE,
                    ],
                ],
            },
        },
        {
            name: 'id',
            width: 1,
            hidden: true,
            cellConfig: {
                type: SkyNetSpreadSheetCellType.ID,
            },
        },
    ]

    return {
        id: 'Fees',
        rowsCounter: true,
        emptyRows: 1,
        addRowMenuOption: true,
        enableRangeSelection: true,
        enableRowSelection: true,
        stickyTopRows: 1,
        headerRow: true,
        fields,
    }
}

export default getFeesSpreadSheetConfig
